import { Link } from 'react-router-dom';
import { ROUTES } from '@/shared/constants/routes';

interface Props {
  roleId: string;
  roleName: string;
}

export function RoleLink({ roleId, roleName }: Props) {
  return (
    <Link
      to={`${ROUTES.userManagement}?tab=roles&roleId=${roleId}`}
      style={{ fontSize: '0.75rem', color: 'inherit' }}
    >
      {roleName}
    </Link>
  );
}
